import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const pelletHardness = {
    jpath: ['spectra', 'pelletHardness'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default pelletHardness;
//# sourceMappingURL=pelletHardness.js.map